<template>
    <div class="error-state-wrapper">
        <!-- Icon -->
        <icon-error-fill class="icon"/>
        <!-- Message -->
        <div v-for="(message, index) in messageParsed" class="message" :key="`modalError${index}Message`">{{message}}</div>
    </div>
</template>

<script setup>
import IconErrorFill from '@/assets/icons/error-fill.svg'

/* Vue */
import { computed } from 'vue'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/** Props received
@message { String } - message to display in our error state
*/
const props = defineProps({
	message: String
})

/* Computed for Message */
const messageParsed = computed(() => {
	const message = props.message || t('emptyStates.genericFeatureErrorMessage')
	return !Array.isArray(message) ? message.split('\n') : message
})
</script>

<style lang="scss" scoped>
.error-state-wrapper {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
    gap: 8px;

    .icon {
        height: 72px;
        width: 72px;

        :deep(.change-color-fill) {
            fill: var(--negative);
        }
    }

    .message {
        padding: 0 16px;
        @include H5-Medium;
        line-height: 20px;
        color: var(--negative);
        text-align: center;
    }
}
</style>
